import StorefrontIcon from '@mui/icons-material/Storefront';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import ListAltIcon from '@mui/icons-material/ListAlt';

const icoMenu = {
    StorefrontIcon,
    AssignmentReturnedIcon,
    ListAltIcon
};

// ==============================|| VENTAS MENU ITEMS - DOCTOR ||============================== //

const venta = {
    id: 'venta',
    title: '',
    type: 'group',
    children: [
        {
            id: 'ventasMainMenu',
            title: 'Ventas',
            type: 'collapse',
            icon: icoMenu.StorefrontIcon,
            children: [
                {
                    id: 'devoluciones_venta',
                    title: 'Devoluciones Ventas',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/busqueda-factura-lote'
                },
                {
                    id: 'devoluciones_factura_migrada_cxc',
                    title: 'Devoluciones CxC sistema anterior',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/busqueda-factura-migrada-cxc'
                },
                {
                    id: 'devoluciones_sistema_anterior_sin_cxc',
                    title: 'Devolución sistema anterior sin CxC',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/devoluciones-sistema-anterior-sin-cxc'
                },
                {
                    id: 'list_devoluciones_venta',
                    title: 'Lista Devoluciones Ventas',
                    icon: icoMenu.ListAltIcon,
                    type: 'item',
                    url: '/user/list-devoluciones-ventas'
                },
                {
                    id: 'list_nota_credito',
                    title: 'Lista Nota Crédito',
                    icon: icoMenu.ListAltIcon,
                    type: 'item',
                    url: '/user/list-nota-credito'
                }
            ]
        }
    ]
};

export default venta;
